import {
  getOriginalHeight,
  getOriginalWidth,
} from './index';

import { getLayoutObjectByLayoutId } from './layouts';

export function setEditorLayout(page, layouts, bookProperties) {
  const getLayoutSizes = getLayoutObjectByLayoutId(page.layout, layouts);

  let ratio = 1;
  let coverWidth = 1212;
  let coverHeight = 616;

  const bookSizes = bookProperties;

  if (getLayoutSizes) {
    const {
      width: layoutWidth,
      height: layoutHeight,
    } = getLayoutSizes;

    coverWidth = layoutWidth;
    coverHeight = layoutHeight;
    const editorDOM = document.querySelector('.Editor');

    if (editorDOM) {
      if (getLayoutSizes.isCover) {
        ratio = editorDOM.offsetHeight / coverHeight;
      } else {
        ratio = editorDOM.offsetHeight / getOriginalHeight(bookSizes);
        if (getOriginalHeight(bookSizes) * ratio * 2 > editorDOM.offsetWidth) {
          ratio = editorDOM.offsetWidth / (getOriginalHeight(bookSizes) * 2);
        }
      }
    }

    const canvasWidth = layoutWidth;

    const canvasHigher = Math.round(layoutWidth * (layoutHeight / layoutWidth));

    const isProportional = layoutWidth / 2 === layoutHeight;
    coverWidth = isProportional ? canvasWidth : layoutWidth;

    const isHeighter = (layoutHeight * 2) < layoutWidth;
    coverHeight = isHeighter ? canvasHigher : layoutHeight;


    const isLower = (layoutHeight * 2) > layoutWidth;
    if (isLower) {
      coverHeight = canvasHigher;
    }

    if ((layoutWidth / layoutHeight) < 0.5) {
      coverWidth = Math.round(((layoutWidth)));
      coverHeight = Math.round(((layoutHeight)));
    }
  }

  let width = Math.floor(coverWidth * ratio);
  let height = Math.floor(coverHeight * ratio);

  if (!page.isCover) {
    width = Math.floor(getOriginalWidth(bookSizes) * ratio);
    height = Math.floor(getOriginalHeight(bookSizes) * ratio);
  }


  return {
    width,
    height,
  };
}



// WEBPACK FOOTER //
// ./src/redux/helpers/editor.js